// extracted by mini-css-extract-plugin
export default {"borrowButton":"BorrowLink_borrowButton__Ak2Lc","borrowIcon":"BorrowLink_borrowIcon__TZQz6"};